module.exports = __webpack_public_path__ + "img/icon36.b8bd85b5.png";